import React from "react"
import Chip from "material-ui/Chip"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import strings from "../../localization/strings"
import { red500, green500 } from "material-ui/styles/colors"
import AccountStore from "../..//stores/AccountStore"
interface IProps {
    title: string
    hierarchyItemId: string
    maxWidth?: number
    onClick?(): void

    //Employee->Timecard->PunchDrawerTable    
    isPunchListTable?: boolean
    hierarchyColWidth?: number
    error?: boolean
}

const HierarchyItemChip: React.SFC<IProps> = (props: IProps) => {
    const hierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(props.hierarchyItemId)
    return (
        <div>
            <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.3)" }}>
                {props.title}
            </div>
            <Chip
                data-intercom-target={"Select-Hierarchy"}
                style={{ cursor: "pointer", margin: 2, height: 35, width: props.isPunchListTable ? props.hierarchyColWidth : "min-content" }}
                onClick={() => props.onClick && props.onClick()}
            >
                <div
                    className="TextOverflow"
                    style={{
                        minWidth: 75,
                        maxWidth: !props.isPunchListTable && props.maxWidth ? props.maxWidth : 250,
                        width: props.isPunchListTable && props.hierarchyColWidth - 20,
                        color: props.hierarchyItemId === AccountStore.DiffHierarchyLevel ?
                            green500 :
                            (hierarchyName === strings.Hierarchy_Removed || props.error) && red500,
                        fontSize: props.isPunchListTable && 12
                    }}
                    title={hierarchyName && hierarchyName !== strings.Hierarchy_Removed && hierarchyHelper.getFullPathLabel(props.hierarchyItemId)}
                >
                    {hierarchyName}
                </div>
            </Chip>
        </div>
    )
}

export default HierarchyItemChip
